import React from 'react';
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function UnsavedChangesDialog({ open, onSave, onDiscard, onCancel, saving }) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>{t('unsavedChanges.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('unsavedChanges.message')}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button onClick={onDiscard} color="error">
          {t('unsavedChanges.discard')}
        </Button>
        <Box sx={{ flex: 1 }} />
        <Button onClick={onCancel} variant="outlined">
          {t('unsavedChanges.cancel')}
        </Button>
        <Button
          onClick={onSave}
          variant="contained"
          disabled={saving}
          startIcon={saving ? <CircularProgress size={16} /> : null}
        >
          {t('unsavedChanges.save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
